const hasCommonItem = (array1, array2) =>
  array1.some((item) => array2.includes(item))

export default hasCommonItem
